import { styled, getSize } from '../lib/styles';
export const HoverMarker = styled.span.attrs(({
  hoverMarkerStyle: {
    height = '100%',
    top = 0
  } = {}
}) => ({
  style: {
    height: getSize(height),
    top: getSize(top)
  }
})).withConfig({
  displayName: "HoverStyles__HoverMarker",
  componentId: "sc-1x2wbr5-0"
})(["border:3px solid;border-color:", ";bottom:0;position:absolute;left:0;right:0;width:100%;"], ({
  canDrop,
  isOver,
  isSameTime,
  theme
}) => {
  if (isOver && !isSameTime) {
    if (!canDrop) {
      return theme.color['fill-alert-default'];
    }
    return theme.color['fill-info-default'];
  }
  return 'transparent';
});